import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateConvert'
})
export class DateConvertPipe implements PipeTransform {
  transform(dateString: string): string {
    if (!dateString || dateString.length !== 6) {
      return 'Invalid Date';
    }

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4);
    const monthName = this.getMonthName(parseInt(month, 10));

    return `${monthName} ${year}`;
  }

  private getMonthName(month: number): string {
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];  

    if (month >= 1 && month <= 12) {
      return months[month - 1];
    } else {
      return 'Invalid Month';
    }
  }
}
